import {initializeTextEditor} from "./texteditor";
import {initializeCodeEditor} from "../dashboard/components/code-editor";
import {initializeDropzone} from "../dashboard/components/dropzone";

$(document).on('click', '.btn-modal', function () {
    triggerModal($(this).data('action'));
});

$(document).on('click', '.btn-modal-info', function (e) {
    $('#modal-info-title').text($(this).data('title'));
    $('#modal-info-description').html($(this).data('description'));
    $('#modal-info').modal('show');
});

// Fixes the tooltip button when the field has the required *
$('.btn-modal-info').each(function () {
    if ($(this).parent().find('label.required').length > 0) {
        $(this).css('margin-left', '8px');
    }
});

/**
 * Trigger modal
 *
 * @param action
 * @param modal
 */
function triggerModal(action, modal = $('#modal')) {
    new Load(true);
    $('[data-bs-toggle="tooltip"]').tooltip('dispose');

    $.ajax({
        url: action,
        type: 'GET',
        dataType: 'json',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
        success: function (data) {
            let hasSize = false;

            if (data.message !== undefined && data.message.length > 0) {
                Notification.message("Success", data.message, 'success');
            }

            if (data.view === undefined || data.view.length === 0) {
                new Load(false);
                dispatchEvent(new Event('load'));
                return;
            }
            modal.find('.modal-dialog').html(data.view);

            let sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
            sizes.forEach(function (size) {
                if (modal.find('.modal-dialog').hasClass('modal-' + size)) {
                    modal.find('.modal-dialog').removeClass('modal-' + size);
                }
            });

            if (typeof data.size !== "undefined") {
                modal.find('.modal-dialog').addClass('modal-' + data.size);
                hasSize = true;
            }

            if (!hasSize) {
                modal.find('.modal-dialog').addClass('modal-md');
            }

            setTimeout(function () {
                setTimeout(function () {
                    initializePlugins(false);
                }, 500);
                if (!modal.hasClass('show')) {
                    modal.modal('show');
                }
            }, 100);
            new Load(false);
            dispatchEvent(new Event('load'));

            if (data.scrollable !== undefined && data.scrollable === true) {
                $('#modal').find('.modal-dialog').addClass('modal-dialog-scrollable');
            } else {
                $('#modal').find('.modal-dialog').removeClass('modal-dialog-scrollable');
            }
        },
        error: function (data) {
            let response = JSON.parse(data.responseText);
            new Load(false);
            Notification.message("Error", response.message, 'danger');
        }
    });
}

$(document).on('change', '.menu-type-dropdown', function () {
    triggerModal($(this).data('action') + '?type=' + $(this).val());
});


window.triggerModal = triggerModal;
